// extracted by mini-css-extract-plugin
export default {"full-screen-loader":"FullScreenLoader_full-screen-loader__HixWH"};